export default __webpack_public_path__ + "static/media/no_image.d09e5038.jpg";